import { shallowRef } from 'vue'

const isGroupCallOpen = shallowRef(false)
const groupCallId = shallowRef<number | null>(null)

export function useGroupCall() {
  function openGroupCall(id: number) {
    groupCallId.value = id
    isGroupCallOpen.value = true
  }

  function closeGroupCall() {
    isGroupCallOpen.value = false
    groupCallId.value = null
  }

  return {
    isGroupCallOpen,
    groupCallId,
    openGroupCall,
    closeGroupCall
  }
}
